<template>
    <div class="py-0">
        <div class="layout-box">
            <slot></slot>
        </div>
    </div>
</template>

<script setup lang="ts"></script>
